export default "__VITE_ASSET__CwZe_Z4___"